import { KeyboardEvent } from 'react'

export function useInputFieldKeyHandlers() {
  const handleTextFieldsKeyDown = (
    event: KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (event.code === 'Space' && event.currentTarget.value.length === 0) {
      event.preventDefault()
    }
  }

  const handlePhoneFieldKeyDown = (
    event: KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (
      (event.code === 'Space' && event.currentTarget.value.length === 0) ||
      (event.code === 'Space' &&
        event.currentTarget.value.length > 0 &&
        event.currentTarget.value.slice(-1) === ' ')
    ) {
      event.preventDefault()
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.currentTarget.id === 'phone') {
      handlePhoneFieldKeyDown(event)
      return
    }
    handleTextFieldsKeyDown(event)
  }

  return { handleKeyDown }
}
